import * as types from 'modules/checklists/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export type ChecklistUiDuplicateVisibleReducer = boolean;

const initialState: ChecklistUiDuplicateVisibleReducer = false;

const open = (): ChecklistUiDuplicateVisibleReducer => true;

const close = (): ChecklistUiDuplicateVisibleReducer => false;

export default createReducer(initialState, {
  [types.DISPLAY_CHECKLIST_DUPLICATE_MODAL]: open,
  [types.HIDE_CHECKLIST_DUPLICATE_MODAL]: close,
  [types.DUPLICATE_CHECKLIST_SUCCESS]: close,
});
